// ManufacturingSupplierReducer.js — Manufacturing tab (new standalone
// module) > Suppliers page. Wired into rootReducer.js as `manufacturingSuppliers`.

const initialState = {
  suppliers: [],
  loading: false,
  actionLoading: false,
  error: null
};

const ManufacturingSupplierReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_MFG_SUPPLIERS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_MFG_SUPPLIERS_SUCCESS':
      return { ...state, loading: false, suppliers: action.payload, error: null };
    case 'FETCH_MFG_SUPPLIERS_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case 'CREATE_MFG_SUPPLIER_REQUEST':
    case 'UPDATE_MFG_SUPPLIER_REQUEST':
    case 'DELETE_MFG_SUPPLIER_REQUEST':
      return { ...state, actionLoading: true, error: null };

    case 'CREATE_MFG_SUPPLIER_SUCCESS':
      return { ...state, actionLoading: false, suppliers: [action.payload, ...state.suppliers] };
    case 'UPDATE_MFG_SUPPLIER_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        suppliers: state.suppliers.map((s) => (s.id === action.payload?.id ? { ...s, ...action.payload } : s))
      };
    case 'DELETE_MFG_SUPPLIER_SUCCESS':
      return { ...state, actionLoading: false, suppliers: state.suppliers.filter((s) => s.id !== action.payload) };

    case 'CREATE_MFG_SUPPLIER_FAILURE':
    case 'UPDATE_MFG_SUPPLIER_FAILURE':
    case 'DELETE_MFG_SUPPLIER_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    default:
      return state;
  }
};

export default ManufacturingSupplierReducer;
